<template>
    <div>
        <card-header title="New Session" icon="fa-plus"/>

        <card-body>
            <session-form v-if="conference.id" :conf="conference" :session="session"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">

                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!valid"
                    ><i class="fas fa-plus mr-2"></i>New Session
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from "@/http_client";
    import SessionForm from "./SessionForm";

    import moment from "moment";

    export default {
        components: {SessionForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                session: {
                    type: 'live',
                    allowed_types: [],
                    media_id: null,
                    log_minutes: null,
                    start_at: null,
                    end_at: null,
                    is_active: 1
                }
            };
        },
        computed: {
            valid: function() {
                let valid = false;

                if (this.session.type === 'live') {
                    valid = this.session.title
                        && this.session.start_at
                        && this.session.end_at
                        && this.session.track_id
                        && this.session.group_id;
                } else if (this.session.type === 'remote') {
                    valid = this.session.title
                        && this.session.start_at
                        && this.session.end_at
                        && this.session.track_id
                        && this.session.group_id;
                } else if (this.session.type === 'on-demand') {
                    valid = this.session.title
                        && this.session.media_id
                        && this.session.max_log_minutes !== undefined
                        && this.session.track_id
                        && this.session.group_id;
                }

                return valid;
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);

                let payload = {conference_id: this.props.confId, ...this.session};
                payload.allowed_types = JSON.stringify(payload.allowed_types);

                http.post('conferences/' + this.props.confId + '/sessions', payload, {force: true}).then(response => {
                    this.$reloadCard('conf-sessions');
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the session.');
                    this.$emit('loading', false);
                });
            },
            loadConference: function(force) {
                this.$emit('loading', true);

                http.get('conferences/' + this.props.confId, {force}).then(response => {
                    response.data.start_at = moment(response.data.start_at).toDate();
                    response.data.end_at = moment(response.data.end_at).toDate();

                    this.conference = response.data;

                    this.$emit('loading', false);
                }).catch(err => {

                });
            }
        },
        mounted() {
            this.loadConference();
        }
    };
</script>
